import React from "react";
import "./FAQContent.css";
import Floaticons from "./Floaticons";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";
import { FaqData } from "../data/faqdata.js";
import Carousel from "nuka-carousel";
import { display } from "@mui/system";

function FAQContent() {
  const CustomExpandIcon = () => {
    return (
      <Box
        sx={{
          ".Mui-expanded & > .collapsIcon": {
            display: "none",
          },
          ".expandIcon": {
            display: "none",
          },
          ".Mui-expanded & > .expandIcon": {
            display: "block",
          },
        }}
      >
        <div className="expandIcon">
          <img src="images/FAQ/Minus.png" alt="minus-icon" />
        </div>
        <div className="collapsIcon">
          <img src="images/FAQ/Plus.png" alt="plus-icon" />
        </div>
      </Box>
    );
  };
  return (
    <>
      <div id="FaqContent">
        <div className="main-banner">
          <img
            src="/images/FAQ/faqbanner.png"
            alt="FAQ Banner"
            className="banner-img"
          />
          <h1 class="visually-hidden">FAQs</h1>
          <img
            src="images/Home/banner-strip.png"
            alt="strip"
            className="strip-img"
          />
          <div className="announcemnt-box">
            <p>
              <img
                src="images/Home/speaker.png"
                alt="speaker"
                className="speaker-img"
              />
              <marquee
                width="92%"
                direction="left"
                style={{ display: "inline-block", verticalAlign: "middle" }}
              >
                {" "}
                <b>Come Join Us</b> on an exhilarating learning Journey on ABC
                University Platform!!!
              </marquee>
            </p>
          </div>
          <Floaticons />
        </div>
        <div className="main-container">
          <div className="header-wrapper">
            <img
              src="/images/FAQ/faqtile.png"
              alt="FAQ-icon"
              className="faq-icon"
            />
          </div>
          <div className="carousel-items">
            <Carousel
              slidesToShow={1}
              slidesToScroll={1}
              defaultControlsConfig={{
                nextButtonStyle: { display: "none" },
                prevButtonStyle: { display: "none" },
              }}
              wrapAround={true}
              dragging={false}
            >
              <div>
                {FaqData.map((item) => {
                  return (
                    <>
                      {item.id <= 10 && (
                        <Accordion className="faq-accordion-container">
                          <AccordionSummary sx={{ borderRadius: "15px" }}>
                            <Typography className="faq-accordion-box">
                              <span>{item.Question}</span>
                              <span>
                                <CustomExpandIcon />
                              </span>
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails className="faq-answer-content">
                            <div className="faq-answer-content-box">
                              <div
                                className="faq-answer-content-row"
                                dangerouslySetInnerHTML={{
                                  __html: item.Answer,
                                }}
                              ></div>
                            </div>
                          </AccordionDetails>
                        </Accordion>
                      )}
                    </>
                  );
                })}
              </div>
              {/* <div>
                {FaqData.map((item) => {
                  return (
                    <>
                      {item.id > 9 && item.id <= 18 && (
                        <Accordion className="faq-accordion-container">
                          <AccordionSummary sx={{ borderRadius: "15px" }}>
                            <Typography className="faq-accordion-box">
                              <span>{item.Question}</span>
                              <span>
                                <CustomExpandIcon />
                              </span>
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails className="faq-answer-content">
                            <div className="faq-answer-content-box">
                              <div
                                className="faq-answer-content-row"
                                dangerouslySetInnerHTML={{
                                  __html: item.Answer,
                                }}
                              ></div>
                            </div>
                          </AccordionDetails>
                        </Accordion>
                      )}
                    </>
                  );
                })}
              </div> */}
              <div>
                {FaqData.map((item) => {
                  return (
                    <>
                      {item.id > 10 && (
                        <Accordion className="faq-accordion-container">
                          <AccordionSummary sx={{ borderRadius: "15px" }}>
                            <Typography className="faq-accordion-box">
                              <span>{item.Question}</span>
                              <span>
                                <CustomExpandIcon />
                              </span>
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails className="faq-answer-content">
                            <div className="faq-answer-content-box">
                              <div
                                className="faq-answer-content-row"
                                dangerouslySetInnerHTML={{
                                  __html: item.Answer,
                                }}
                              ></div>
                            </div>
                          </AccordionDetails>
                        </Accordion>
                      )}
                    </>
                  );
                })}
              </div>
            </Carousel>
          </div>
        </div>
      </div>
    </>
  );
}

export default FAQContent;
